import { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import ArticleDisplay from '../ArticleDisplay'
import { setConfiguration } from '../../../store/actions'
import { graphqlFetch } from '../../cdl-react-components/utilities'

class RecentArticles extends Component {
    render() {
        const { recentArticles, embedded } = this.props

        let articles1 = []
        let articles2 = []
        if (recentArticles) {
            articles1 = [recentArticles[0], recentArticles[1], recentArticles[2]]
            articles2 = [recentArticles[3], recentArticles[4], recentArticles[5]]
        }

        return recentArticles ? (
            <Fragment>
                <div className={'recent-articles' + (embedded ? ' recent-articles--embedded' : '')}>
                    <div className="recent-articles__articles">
                        { articles1.map((article, i) => 
                            <ArticleDisplay key={'article1-display--' + i} article={article} embedded={embedded} />)}
                    </div>
                    <div className="recent-articles__articles">
                        { articles2.map((article, i) => 
                            <ArticleDisplay key={'article2-display--' + i} article={article} embedded={embedded} />)}
                    </div>
                </div>
                { !embedded ?? <hr /> }
            </Fragment>) : null
    }

    componentDidMount() {
        if (!this.props.recentArticles) {
            graphqlFetch('wcms3', `
                query {
                    articles (
                        order: { publicationDate: DESC }
                        take: 6
                    ) {
                        items {
                            id
                            title
                            subtitle
                            image
                            publication_date: publicationDate
                            featuredArticle
                            synopsis
                            article_type: contentArticleArticleTypes {
                                articletype {
                                    id
                                    name
                                }
                            }
                            authors: contentArticleAuthors {
                                author {
                                    id
                                    name
                                }
                            }
                            ep_type: epType {
                                id
                                name
                            }
                        }
                    }
                }`)
                .then(res => {
                    const articles = 
                        res.data.articles.items                    
                            .map(article => ({
                                ...article,
                                
                                ep_type: article.ep_type?.name,
                                article_type: article.article_type?.map(x => ({ ...x.articletype })),
                                authors: article.authors?.map(x => x.author)
                            }))

                    this.props.setRecentArticles(articles)
                })
        }
    }
}

const mapStateToProps = ({ data }) => ({ recentArticles: data.configuration.recentArticles })
const mapDispatchToProps = (dispatch) => ({ setRecentArticles: recentArticles => dispatch(setConfiguration({ recentArticles }))})

export default connect(mapStateToProps, mapDispatchToProps)(RecentArticles)